var $5c9f23837bf5a870$exports = {};
// WTF 09.04 - pętle
// pętla for
for(let i = 0; i < 3; i++)console.log(`${i} wykonanie pętli`);
let $5c9f23837bf5a870$var$number = 0;
console.log($5c9f23837bf5a870$var$number++);
console.log($5c9f23837bf5a870$var$number);
//  Wypiszmy elementy tablicy
const $5c9f23837bf5a870$var$elements = [
    "\uD83D\uDE0E",
    "\uD83E\uDD2F",
    "\uD83D\uDE31"
];
for(let i = 0; i < $5c9f23837bf5a870$var$elements.length; i++)console.log(`na miejscu ${i} jest ${$5c9f23837bf5a870$var$elements[i]}`);
// pętla while
let $5c9f23837bf5a870$var$n = 3;
while($5c9f23837bf5a870$var$n < 9){
    console.log($5c9f23837bf5a870$var$n);
    $5c9f23837bf5a870$var$n = $5c9f23837bf5a870$var$n + 3;
}
console.log($5c9f23837bf5a870$var$n);
// pętla do while
let $5c9f23837bf5a870$var$m = 2;
do {
    console.log($5c9f23837bf5a870$var$m);
    $5c9f23837bf5a870$var$m = $5c9f23837bf5a870$var$m + 2;
}while ($5c9f23837bf5a870$var$m < 9);
console.log($5c9f23837bf5a870$var$m);
// for in
const $5c9f23837bf5a870$var$deathStar = {
    diameter: 120000,
    fire: (target)=>{
        console.log(`${target} destroyed 💣`);
    },
    isOperating: true,
    levels: 357,
    name: "Death Star",
    population: 10000,
    comander: {
        name: "darth vader"
    }
};
for(property in $5c9f23837bf5a870$var$deathStar){
    console.log(property);
    console.log(`${property}: ${$5c9f23837bf5a870$var$deathStar[property]}`);
}
for (let element of $5c9f23837bf5a870$var$elements)console.log(element);
let $5c9f23837bf5a870$var$myNumber = 13;
const $5c9f23837bf5a870$var$myFunction = (a)=>{
    const b = a * 3;
    const c = b * 7;
    return b + c;
};
for(let i = 0; i < $5c9f23837bf5a870$var$elements.length; i++){
    $5c9f23837bf5a870$var$myNumber = $5c9f23837bf5a870$var$myNumber * (i + 1);
    $5c9f23837bf5a870$var$myFunction(i);
}


//# sourceMappingURL=index.bc7485a4.js.map
